// extracted by mini-css-extract-plugin
export var adCard = "_ok-8";
export var adCardBorder = "_ok-5";
export var arbiterButtonIcon = "_ok-p";
export var buttonIcon = "_ok-o";
export var container = "_ok-e";
export var copyButton = "_ok-m";
export var darkGrey = "_ok-u";
export var deliveryDate = "_ok-2";
export var divider = "_ok-n";
export var editModeWrapper = "_ok-7";
export var empty = "_ok-a";
export var errorIcon = "_ok-d";
export var filledCircle = "_ok-4";
export var fulfillmentFooter = "_ok-j";
export var grey = "_ok-s";
export var header = "_ok-i";
export var headerWrapper = "_ok-h";
export var highlighted = "_ok-6";
export var historyEntry = "_ok-3";
export var mobileColumn = "_ok-v";
export var mobileColumnReverse = "_ok-w";
export var orderDetailsContainer = "_ok-g";
export var orderMetadata = "_ok-l";
export var orderMetadataWrapper = "_ok-k";
export var packagesContainer = "_ok-b";
export var product = "_ok-y";
export var productImage = "_ok-z";
export var productInfo = "_ok-x";
export var productTitle = "_ok-10";
export var strikethrough = "_ok-t";
export var tinyText = "_ok-r";
export var title = "_ok-9";
export var trackerCard = "_ok-1";
export var trackerCardWrapper = "_ok-0";
export var trackingContainer = "_ok-f";
export var trackingTitle = "_ok-c";
export var xTinyText = "_ok-q";